// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollButton_button__1f_zC","hidden":"ScrollButton_hidden__1fsm8"};